export const ROOT: string = '/';
export const ADD: string = '/add';
export const ABOUT: string = '/about';
export const EXPEDITION: string = '/expedition';
export const HOW: string = '/how';
export const THEME: string = '/theme';
export const PDF: string = '/pdf';
export const MAP: string = '/map';
export const SEARCH: string = '/search';
export const PRIVACY: string = '/privacy';
